<script>
  import Input from "../../../../auto-mps/parts/inputs/Input.svelte";
  import InputContainer from "../../../../auto-mps/parts/inputs/InputContainer.svelte";

  /**
   * @type {string}
   */
  export let name

  /**
   * @type {string|null|undefined}
   */
  export let label

  /**
   * @type {string|null|undefined}
   */
  export let error

  export let disabled = false
</script>

<InputContainer>
  <span slot="label">
    {#if label}
      {label}
    {:else}
      <slot/>
    {/if}
  </span>
  <Input name={name} disabled={disabled}/>
  <span class="error">
    {#if error}
      {error}
    {/if}
  </span>
</InputContainer>

<style>
  .error {
    color: red;
    font-size: 0.9rem;
  }
</style>
